import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { InvoicesByCounterpartyItem } from "@common/types/invoice";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CopyOnClick } from "@design-system/CopyOnClick/CopyOnClick";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import { CopyIcon } from "@icons";
import {
    CustomerTooltipContent,
    CustomerTooltipField,
} from "../../CustomerTooltipContent";
import styles from "./CustomerNameCell.module.scss";

export const CustomerNameCell = memo(
    ({
        row,
    }: CellContext<ViewTableFeatures, InvoicesByCounterpartyItem, unknown>) => {
        const { counterparty } = row.original;

        if (!counterparty) {
            return (
                <ViewTableCell>
                    <div className={styles.customerContent}>
                        <span className={styles.noCustomer}>No customer</span>
                    </div>
                </ViewTableCell>
            );
        }

        const tooltipFields: CustomerTooltipField[] = [
            { label: "Customer", value: counterparty.name },
        ];
        if (counterparty.email) {
            tooltipFields.push({ label: "Email", value: counterparty.email });
        }

        return (
            <ViewTableCell>
                <div className={styles.customerContent}>
                    <Tooltip
                        content={
                            <CustomerTooltipContent fields={tooltipFields} />
                        }
                        side="bottom"
                    >
                        <span className={styles.customerName}>
                            {counterparty.name}
                        </span>
                    </Tooltip>
                    {counterparty.email && (
                        <CopyOnClick
                            className={styles.customerEmail}
                            value={counterparty.email}
                            tooltipText="Copy email"
                            stopPropagation
                        >
                            <span className={styles.customerEmailText}>
                                {counterparty.email}
                            </span>
                            <CopyIcon className={styles.copyIcon} />
                        </CopyOnClick>
                    )}
                </div>
            </ViewTableCell>
        );
    },
);
